<!--工单详情-->
<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="知识详情" size="75%" :before-close="handleClose" :visible.sync="drawer"
               direction="rtl" append-to-body custom-class="demo-drawer" ref="drawer" class="details2">
      <div class="demo-drawer__content">
        <template>
          <div>
            <!-- 服务商 -->
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class="" style="padding: 5px;border-bottom: 1px solid #ededed">

                  </div>
                </div>
                <div class="d-cont edit-mce-box">
                  <div class="d-item">
                    <div class="title first">
                      <!-- <b><span>节点图</span></b> -->
                    </div>
                    <div style="padding: 0 10px;">
                      <!-- 标题 -->
                      <div class="title">{{ formData.title }}</div>
                      <!-- 时间 -->
                      <div class="source"> {{ formData.modifyTime }}
                        <!-- <span>关键字：高效 效率 完善</span> -->
                        <span>类别：{{ formData.bulletinTypeName }}</span>
                      </div>
                      <div>
                        <div style="margin:10px 0">
                          <!-- {{formData.content }} -->
                          <div class="content_item" v-html="formData.content"></div>
                          <!-- <div><el-image :src="imgs"></el-image></div> -->
                        </div>


                      </div>

                    </div>
                  </div>
                  <div class="d-item" style="height: 60vh;">
                    <el-row :gutter="30">
                      <el-col :span="6">
                        <div class="title first">
                          <b>附件信息</b>
<!--                          <el-upload style="display:flex; margin-top: -6px; float: right"-->
<!--                                     class="upload-demo"-->
<!--                                     ref="upload"-->
<!--                                     :action="api.uploadFileUrl"-->
<!--                                     accept=".docx,.doc,.txt,.pdf,.xlsx"-->
<!--                                     v-if="fileList.length < 5"-->
<!--                                     :show-file-list="false"-->
<!--                                     :on-success="(res,file, fileList) => {handleFileSuccess(res,file, fileList)}"-->
<!--                                     :headers="headers"-->
<!--                                     :auto-upload="true"-->
<!--                          >-->
<!--                            <el-button type="primary" class="button-sty btn_zdy2">-->
<!--                              <i class="el-icon-plus"></i>-->
<!--                              附件-->
<!--                            </el-button>-->
<!--                          </el-upload>-->
                        </div>
                        <div class="current-info">
                          <vxe-table ref="filterTable"
                                     class="table_item pic_item mytable-scrollbar"
                                     :column-config="{ resizable: true }"
                                     style="width: 100%;"
                                     :stripe="true"
                                     :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                     :row-config="{height: 30,isHover: true,padding: 0,}"
                                     :row-style="{ fontSize: '12px',  }"
                                     show-overflow
                                     :data="fileList"
                          >
                            <vxe-column field="name" title="附件名称" width="">
                              <template #default="{row}">
                                <a :href="row.url" :download="row.name">{{row.name}}</a>
                              </template>
                            </vxe-column>
                          </vxe-table>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <div style="height: 10px;"></div>
                </div>

              </el-form>
            </div>
          </div>
        </template>

      </div>
    </el-drawer>
  </div>
</template>
<script>
import api from "@/api/projectApi";

export default {
  inject: ['reload'],
  name: 'detailDialog',
  props: ['multi', 'row1'],
  components: {},
  created() {
    this.formData = this.row1
    console.log(this.formData, "传过来formData的值");
    //设置已读
    this.doReaded(this.row1.id,this);
  },
  data() {
    return {
      fileList:[],
      dataId: '',
      drawer: true,
      formData: {},
      imgs: '',
    }
  },
  mounted() {
    //   var obj=this.formData.content
    //   // console.log(obj,"截取的")
    //   let pi=obj.match(/">(\S*)</)[1];
    //   let pi2=obj.match(/p>(\S*)<img/)[1];
    //   if(pi){
    //     this.content=pi
    //   }else{
    //     this.content=pi2
    //   }
    //   // 图片
    //   let imgs = obj.match(/"(\S*)"/)[1];
    //  this.imgs=imgs
// console.log(pi,pi2,"截取的文字")


    //   this.getData();
    //   console.log(this.dataId, "_dataId的值");
  },
  methods: {
    doReaded(id,that) {
      this.$mask.open()
      this.$http({
        url: api.basBulletin.doReadedUrl,
        method: 'post',
        data: {
          id: id
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        let data = response.data.data
        that.formData.content = data.content
        that.formData.modifyTime = data.modifyTime
        if(data.file1){
          let r = {name:data.file1Name,url:data.file1}
          that.fileList.push(r);
        }
        if(data.file2){
          let r = {name:data.file2Name,url:data.file2}
          that.fileList.push(r);
        }
        if(data.file3){
          let r = {name:data.file3Name,url:data.file3}
          that.fileList.push(r);
        }
        if(data.file4){
          let r = {name:data.file4Name,url:data.file4}
          that.fileList.push(r);
        }
        if(data.file5){
          let r = {name:data.file5Name,url:data.file5}
          that.fileList.push(r);
        }

      })
      this.$mask.close()
    },
    //   getData() {
    //     if (this.dataId && !isNaN(this.dataId)) {
    //       this.$http({
    //         url: api.soOrder.getDataUrl,
    //         method: 'post',
    //         data: {
    //           id: this.dataId
    //         },
    //         isLoading: true,
    //         modalStrictly: true,
    //       }).then(response => {
    //         this.formData = response.data.data

    //         })


    //       }
    //   },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.formData = ''
      this.$emit('closeDA', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.content_item {
  ::v-deep p {
    display: flex;
    flex-direction: column;

    img {
      width: 60%;
      margin: 10px 0;
    }
  }
}

.details2 {

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }
}

.title {
  text-align: center;
  font-size: 30px;
  margin: 10px 0
}

.source {
  color: #a7a7a7;
  margin-bottom: 10px;
  font-size: 16px;

  span {
    margin-left: 20px;
  }
}

.el-image {
  margin: 10px 0;
}</style>
